// Equipment Admin (thread #1399, 2026-09-11) — RTK Query API.
// GET    /equipment-admin/portal/list   — all 351 equipment records, President-gated.
// PATCH  /equipment-admin/portal/update — update a record (MySQL-first TL write, #1399-4).
// DELETE /equipment-admin/portal/delete — delete a record (MySQL-first TL delete, #1399-5).
// Read path: airtable_mirror.equipment_b9gs only (TL Test 2 PASS).
import { BACKEND_URL } from "../../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const equipmentAdminApi = createApi({
  reducerPath: "equipmentAdminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Equipment"],
  endpoints: (builder) => ({
    listEquipment: builder.query({
      query: () => `/equipment-admin/portal/list`,
      providesTags: [{ type: "Equipment", id: "LIST" }],
    }),
    updateEquipment: builder.mutation({
      query: ({ recid, fields }) => ({
        url: `/equipment-admin/portal/update`,
        method: "PATCH",
        body: { recid, fields },
      }),
      invalidatesTags: [{ type: "Equipment", id: "LIST" }],
    }),
    deleteEquipment: builder.mutation({
      query: ({ recid }) => ({
        url: `/equipment-admin/portal/delete`,
        method: "DELETE",
        body: { recid },
      }),
      invalidatesTags: [{ type: "Equipment", id: "LIST" }],
    }),
  }),
});

export const { useListEquipmentQuery, useUpdateEquipmentMutation, useDeleteEquipmentMutation } = equipmentAdminApi;
